// Public presentation only; stored CMS content and the backoffice stay untouched.
export function customerPublicCopy(value, key = "") {
  if (typeof window !== "undefined" && window.location.pathname.startsWith("/admin")) return value;
  if (Array.isArray(value)) return value.map(item => customerPublicCopy(item));
  if (value && typeof value === "object") return Object.fromEntries(Object.entries(value).map(([k, v]) => [k, customerPublicCopy(v, k)]));
  if (typeof value !== "string" || /^(id|slug|type|icon|testid|.*_id)$/.test(key)) return value;
  if (/^(https?:\/\/[^/]*managercargo\.com\/|\/my5999(?:cargo)?(?:$|[?#]))/i.test(value)) return "/mijn-5999cargo";
  if (/^(https?:\/\/|\/)/.test(value)) return value;
  return value.replace(/MY5999(?:\s*Cargo)?|Manager\s*Cargo/gi, "Mijn 5999Cargo");
}